import { jsx, jsxs } from "react/jsx-runtime";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useThemeProps } from "@mui/material";
import { useSlotProps } from "../../../base/index.js";
import { useCalendarConfiguration } from "../context/CalendarRoot.js";
import { calendarNavigatorName, useCalendarNavigatorUtilityClasses } from "./classes.js";
import { Button } from "./components/Button.js";
import { Label } from "./components/Label.js";
import { LabelContainer } from "./components/LabelContainer.js";
import { Root } from "./components/Root.js";
const defaultPrev = /* @__PURE__ */ jsx(ArrowBackIos, { sx: { width: 12 } });
const defaultNext = /* @__PURE__ */ jsx(ArrowForwardIos, { sx: { width: 12 } });
function CalendarNavigator(inProps) {
  const props = useThemeProps({
    name: calendarNavigatorName,
    props: inProps
  });
  const {
    testId = `${calendarNavigatorName}-root`,
    labels,
    prevIcon = defaultPrev,
    nextIcon = defaultNext,
    className,
    components,
    onClickNext,
    onClickPrev,
    disableNext,
    disablePrev,
    componentsProps
  } = props;
  const {
    layout: { monthGap }
  } = useCalendarConfiguration();
  const ownerState = props;
  const utilityClasses = useCalendarNavigatorUtilityClasses(ownerState);
  const rootSlotProps = useSlotProps({
    className: [className, utilityClasses.root],
    ownerState,
    elementType: Root,
    additionalProps: {
      as: components?.Root,
      "data-testid": testId
    },
    externalSlotProps: componentsProps?.root
  });
  const labelContainerSlotProps = useSlotProps({
    className: utilityClasses.labelContainer,
    ownerState,
    elementType: LabelContainer,
    additionalProps: {
      as: components?.LabelContainer,
      monthGap
    },
    externalSlotProps: componentsProps?.labelContainer
  });
  const labelSlotProps = useSlotProps({
    className: utilityClasses.label,
    ownerState,
    elementType: Label,
    additionalProps: { as: components?.Label },
    externalSlotProps: componentsProps?.label
  });
  const buttonSlotProps = useSlotProps({
    className: utilityClasses.button,
    ownerState,
    elementType: Button,
    additionalProps: {
      as: components?.Button,
      type: "button"
    },
    externalSlotProps: componentsProps?.button
  });
  return /* @__PURE__ */ jsxs(Root, { ...rootSlotProps, children: [
    /* @__PURE__ */ jsx(Button, { ...buttonSlotProps, onClick: onClickPrev, disabled: disablePrev, "data-testid": "prev-month", children: prevIcon }),
    /* @__PURE__ */ jsx(LabelContainer, { ...labelContainerSlotProps, children: labels.map(
      (label, idx) => label && /* @__PURE__ */ jsx(Label, { ...labelSlotProps, children: label }, idx)
    ) }),
    /* @__PURE__ */ jsx(Button, { ...buttonSlotProps, onClick: onClickNext, disabled: disableNext, "data-testid": "next-month", children: nextIcon })
  ] });
}
export {
  CalendarNavigator
};
//# sourceMappingURL=CalendarNavigator.js.map
